import {useLingui} from "@lingui/react";

function FormattedRelativeTime({value, unit, style}:{
    value: number,
    style: Intl.RelativeTimeFormatStyle,
    unit: Intl.RelativeTimeFormatUnit
}) {
    const { _, i18n } = useLingui();
    return <span>{new Intl.RelativeTimeFormat(i18n.locale, {
        style,
    }).format(value, unit)}</span>
}

export default FormattedRelativeTime;